const _excluded = ["testId"],
  _excluded2 = ["testId"],
  _excluded3 = ["type"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import cn from 'classnames';
import Decimal from 'decimal.js';
import { addYears, isAfter, startOfDay, startOfYear } from 'date-fns';
import { Autocomplete, Checkbox, KeyboardDatePicker, MenuItem, Spinner, TextButton, TextField, Typography, WithInfoIcon, useStateInRef } from 'seagull';
import { utils } from "../../utils";
import { selectors } from "../../store/state-selectors";
import { decimalFromStr } from "../../infra/utils";
import { getAccountingDetails } from "../../integrations/Accounting/accounting.utils";
import { DiscountPeriodControl } from "./DiscountPeriodControl/DiscountPeriodControl";
import { AdvancedSettingsControl } from "./AdvancedSettingsControl/AdvancedSettingsControl";
import { getPriceIncreaseDateRange } from "../../business-logic/priceIncreaseLogic";
import { PreapprovedAmountControl } from "./PreapprovedAmountControl/PreapprovedAmountControl";
import { PriceIncreaseModel, RoundPrices } from "../../models/PriceIncreaseModel";
import { LimitedTimeDiscountOfferControl } from "./LimitedTimeDiscountOfferControl/LimitedTimeDiscountOfferControl";
import { serviceModel } from "../../models";
import { useIoContext, useStore, useStoreActions } from "../../contexts";
import { Accounting, getSelectedUser } from "../../types/api.model";
import styles from "./ServiceAdvancedSettings.module.scss";
import { useGetSettings } from "./hooks/useGetSettings/useGetSettings";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { StartAutomaticBillingAtControl } from "./StartAutomaticBillingAtControl/StartAutomaticBillingAtControl";
import { pathgen } from 'object-path-generator';
import { overrideTestIds } from 'seagull/utils/getTestId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let AdvancedSetting = /*#__PURE__*/function (AdvancedSetting) {
  AdvancedSetting["Pause"] = "pause";
  AdvancedSetting["BillOnApproval"] = "billOnApproval";
  AdvancedSetting["Prorate"] = "prorate";
  AdvancedSetting["Optional"] = "optional";
  AdvancedSetting["LimitCharges"] = "limitCharges";
  AdvancedSetting["AutoPriceIncrease"] = "autoPriceIncrease";
  AdvancedSetting["QboClasses"] = "qboClasses";
  AdvancedSetting["FinancialCents"] = "financialCents";
  AdvancedSetting["Karbon"] = "karbon";
  AdvancedSetting["LimitedTimeDiscountOffer"] = "limitedTimeDiscountOffer";
  AdvancedSetting["LimitedTimeDiscountOfferForAgreement"] = "limitedTimeDiscountOfferForAgreement";
  AdvancedSetting["PreapprovedAmount"] = "preapprovedAmount";
  AdvancedSetting["StartAutomaticBillingAt"] = "startAutomaticBillingAt";
  return AdvancedSetting;
}({});
const accountingName = getAccountingDetails(Accounting.QBO).fullName;
export function getValidIncreaseOn(increaseOn, now) {
  const today = startOfDay(now);
  return isAfter(increaseOn, today) ? increaseOn : addYears(increaseOn, 1);
}
const dropdownWidth = 274;
function PausedControl(props) {
  const {
    service,
    testId: testPrefix,
    disabled,
    info,
    label,
    disabledTooltip,
    isReadOnly,
    onPausedChange
  } = props;
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    isReadOnly: isReadOnly,
    info: info,
    label: label,
    checked: serviceModel.isPaused(service),
    testid: testPrefix + '-start-paused',
    disabled: disabled,
    disabledTooltip: disabledTooltip,
    onChange: checked => onPausedChange && onPausedChange(service.id, checked)
  }, AdvancedSetting.Pause);
}
function BillOnApprovalControl(props) {
  const {
    service,
    testId: testPrefix,
    disabled,
    label,
    disabledTooltip,
    info,
    isReadOnly,
    onBillOnAcceptanceChange
  } = props;
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    info: info,
    label: label,
    isReadOnly: isReadOnly,
    checked: !serviceModel.isSkipBillingOnAcceptance(service),
    testid: testPrefix + '-bill-on-acceptance',
    disabled: disabled,
    disabledTooltip: disabledTooltip,
    onChange: checked => onBillOnAcceptanceChange && onBillOnAcceptanceChange(service.id, checked)
  }, AdvancedSetting.BillOnApproval);
}
function ProrateControl(props) {
  const {
    service,
    testId: testPrefix,
    disabled,
    disabledTooltip,
    label,
    info,
    isReadOnly,
    onProratedChange
  } = props;
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    info: info,
    label: label,
    isReadOnly: isReadOnly,
    checked: serviceModel.isProrated(service),
    testid: ServiceAdvancedSettingsTestIds.Prorated(testPrefix),
    disabled: disabled,
    disabledTooltip: disabledTooltip,
    onChange: checked => onProratedChange && onProratedChange(service.id, checked)
  }, AdvancedSetting.Prorate);
}
function OptionalControl(props) {
  const {
    service,
    info,
    label,
    disabled,
    disabledTooltip,
    isReadOnly,
    onOptionalChange
  } = props;
  const {
    logBI
  } = useStoreActions();
  const onChangeWithBI = data => {
    logBI(10488, _objectSpread(_objectSpread({}, data), {}, {
      serviceId: service.id,
      serviceName: service.name
    }));
    onOptionalChange && onOptionalChange(service.id, data.optional, data.includedByDefault);
  };
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    info: info,
    label: label,
    disabled: disabled,
    isReadOnly: isReadOnly,
    disabledTooltip: disabledTooltip,
    checked: service.participation.type === 'optional',
    testid: "".concat(service.id, "-toggle-optional"),
    onChange: checked => onChangeWithBI({
      optional: checked,
      includedByDefault: false
    }),
    children: serviceModel.isOptional(service.participation) && /*#__PURE__*/_jsxs("div", {
      className: styles.additionalControl,
      children: [/*#__PURE__*/_jsx(Typography, {
        children: "Set the default state of this service:"
      }), /*#__PURE__*/_jsxs(TextField, {
        select: true,
        size: "small",
        width: dropdownWidth,
        disabled: isReadOnly,
        "data-testid": "".concat(service.id, "-included-dropdown"),
        value: service.participation.optional.includedByDefault.toString(),
        onChange: e => onChangeWithBI({
          optional: true,
          includedByDefault: e.target.value === 'true'
        }),
        children: [/*#__PURE__*/_jsx(MenuItem, {
          "data-testid": "".concat(service.id, "-option-not-included"),
          value: "false",
          children: "Not included in the proposal"
        }), /*#__PURE__*/_jsx(MenuItem, {
          "data-testid": "".concat(service.id, "-option-included"),
          value: "true",
          children: "Included in the proposal"
        })]
      })]
    })
  }, AdvancedSetting.Optional);
}
function LimitChargesControl(props) {
  const {
    service,
    showServiceValidationWarning = false,
    info,
    label,
    isReadOnly,
    onLimitBillingTimesChange
  } = props;
  const {
    logBI
  } = useStoreActions();
  const [wasModified, setWasModified] = useState(false);
  const maxChargesError = serviceModel.validateMaxCharges(service).length > 0;
  const onChangeWithBI = data => {
    logBI(10489, _objectSpread(_objectSpread({}, data), {}, {
      serviceId: service.id,
      serviceName: service.name
    }));
    onLimitBillingTimesChange && onLimitBillingTimesChange(service.id, data.limit, data.count);
  };
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    info: info,
    label: label,
    isReadOnly: isReadOnly,
    checked: serviceModel.maxChargesEnabled(service),
    testid: "".concat(service.id, "-toggle-limit-billing-count"),
    onChange: checked => onChangeWithBI({
      limit: checked,
      count: serviceModel.maxChargesLimit(service)
    }),
    children: serviceModel.maxChargesEnabled(service) && /*#__PURE__*/_jsx("div", {
      className: styles.additionalControl,
      children: /*#__PURE__*/_jsx(TextField, {
        size: "small",
        label: "Number of times",
        width: dropdownWidth,
        disabled: isReadOnly,
        "data-testid": "".concat(service.id, "-limit-billing-count-input"),
        value: serviceModel.maxChargesLimit(service) != null ? serviceModel.maxChargesLimit(service) : '',
        error: maxChargesError && (wasModified || showServiceValidationWarning),
        onChange: e => {
          if (e.target.value !== '' && !Number.isNaN(Number(e.target.value))) {
            setWasModified(true);
            onChangeWithBI({
              limit: true,
              count: Number(e.target.value)
            });
          } else if (e.target.value === '') {
            setWasModified(true);
            onChangeWithBI({
              limit: true,
              count: null
            });
          }
        },
        helperText: maxChargesError && (wasModified || showServiceValidationWarning) ? 'Must be between 1 and 99' : ''
      })
    })
  }, AdvancedSetting.LimitCharges);
}
export let IncreaseMethod = /*#__PURE__*/function (IncreaseMethod) {
  IncreaseMethod["EffectiveDate"] = "effectiveDate";
  IncreaseMethod["Date"] = "date";
  return IncreaseMethod;
}({});
const increaseMethodToText = {
  [IncreaseMethod.EffectiveDate]: 'Every year on agreement anniversary',
  [IncreaseMethod.Date]: 'Every year starting on'
};
const increaseMethodOptions = [{
  value: IncreaseMethod.EffectiveDate
}, {
  value: IncreaseMethod.Date
}];
const roundPricesOptions = [{
  value: RoundPrices.Down1,
  amount: 1
}, {
  value: RoundPrices.Down5,
  amount: 5
}, {
  value: RoundPrices.Down10,
  amount: 10
}];
function getInitialIncreaseMethod(priceIncrease, relationshipState) {
  if (priceIncrease.exists()) {
    return priceIncrease.increaseOn() ? IncreaseMethod.Date : IncreaseMethod.EffectiveDate;
  } else {
    return relationshipState.type === 'awaitingApproval' && !relationshipState.awaitingApproval.effectiveDate ? IncreaseMethod.EffectiveDate : IncreaseMethod.Date;
  }
}
function AutoPriceIncreaseControl(props) {
  const {
    service,
    info,
    label,
    showServiceValidationWarning,
    relationshipState,
    isReadOnly,
    onAutoPriceIncreaseChange
  } = props;
  const disableIncreaseOnAnniversary = relationshipState.type === 'approved';
  const priceIncrease = serviceModel.priceIncrease(service);
  const {
    getNow
  } = useIoContext();
  const [roundPrices, setRoundPrices] = useState(priceIncrease.roundPrices());
  const [increaseOn, setIncreaseOn] = useState(() => priceIncrease.increaseOn() || startOfYear(addYears(getNow(), 1)));
  const [increaseMethod, setIncreaseMethod] = useState(getInitialIncreaseMethod(priceIncrease, relationshipState));
  const [percentIncrease, setPercentIncrease] = useState(!priceIncrease.exists() || priceIncrease.percentIncrease().toNumber() < 0 ? '' : priceIncrease.percentIncrease().toString());
  const nextYearPrice = serviceModel.nextYearPrice(service);
  const hasPriceIncrease = priceIncrease.exists();
  const shouldRoundPrices = roundPrices !== RoundPrices.None;
  const roundPricesError = showServiceValidationWarning && serviceModel.isInvalidRoundPrices(service) ? serviceModel.roundPricesErrorMsg : null;
  const relationshipEffectiveDate = useMemo(() => {
    if (relationshipState.type === 'awaitingApproval') {
      return relationshipState.awaitingApproval.effectiveDate;
    } else if (relationshipState.type === 'approved') {
      return relationshipState.approved.effectiveDate;
    }
    return null;
  }, [relationshipState]);
  const increaseMethodError = serviceModel.isInvalidIncreaseMethod(increaseMethod === IncreaseMethod.Date ? increaseOn : null, relationshipEffectiveDate) ? "Only available when the effective date is 'On Acceptance'." : null;
  const {
    minDate,
    maxDate
  } = useMemo(() => {
    return getPriceIncreaseDateRange(getNow(), relationshipEffectiveDate);
  }, [relationshipEffectiveDate]);
  function handleStateChange(data) {
    if (!onAutoPriceIncreaseChange) return;
    const {
      newIncreaseOn = increaseOn,
      newPercentIncrease = percentIncrease,
      newRoundPrices = roundPrices,
      newIncreaseMethod = increaseMethod
    } = data;
    const validNewIncreaseOn = getValidIncreaseOn(newIncreaseOn, getNow());
    setIncreaseOn(validNewIncreaseOn);
    setPercentIncrease(newPercentIncrease);
    setRoundPrices(newRoundPrices);
    setIncreaseMethod(newIncreaseMethod);
    const priceIncrease = data.enabled ? PriceIncreaseModel.make(newRoundPrices, decimalFromStr(newPercentIncrease) || new Decimal(-1), newIncreaseMethod === IncreaseMethod.Date ? validNewIncreaseOn : null) : PriceIncreaseModel.makeNone();
    onAutoPriceIncreaseChange(service.id, priceIncrease);
  }
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    info: info,
    isReadOnly: isReadOnly,
    label: label,
    labelSuffix: hasPriceIncrease && /*#__PURE__*/_jsxs(Typography, {
      skin: "warning",
      weight: "normal",
      variant: "paragraph2",
      "data-testid": "price-increase-next-year",
      children: ["Next year's price: ", nextYearPrice ? utils.formatDollarAmount(nextYearPrice) : '']
    }),
    checked: hasPriceIncrease,
    testid: "".concat(service.id, "-toggle-price-increase"),
    onChange: checked => handleStateChange({
      enabled: checked
    }),
    children: hasPriceIncrease && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.additionalControl,
        children: [/*#__PURE__*/_jsx(Typography, {
          className: styles.noShrink,
          children: "increase by"
        }), /*#__PURE__*/_jsx(TextField, {
          isMoney: true,
          testid: "price-increase-amount",
          className: styles.noShrink,
          inputProps: {
            min: 0
          },
          disabled: isReadOnly,
          size: "small",
          suffix: "%",
          width: 90,
          value: percentIncrease,
          onChange: e => handleStateChange({
            enabled: true,
            newPercentIncrease: e.target.value
          }),
          error: showServiceValidationWarning && serviceModel.isInvalidPercentIncrease(percentIncrease)
        }), disableIncreaseOnAnniversary ? /*#__PURE__*/_jsx(Typography, {
          className: styles.noShrink,
          children: increaseMethodToText[IncreaseMethod.Date]
        }) : /*#__PURE__*/_jsx(TextField, {
          select: true,
          size: "small",
          testid: "price-increase-method",
          disabled: isReadOnly,
          value: increaseMethod,
          error: !!increaseMethodError,
          helperText: increaseMethodError,
          onChange: e => handleStateChange({
            enabled: true,
            newIncreaseMethod: e.target.value
          }),
          children: increaseMethodOptions.map(_ref => {
            let {
              value
            } = _ref;
            return /*#__PURE__*/_jsx(MenuItem, {
              value: value,
              "data-testid": "price-increase-method-".concat(value),
              children: increaseMethodToText[value]
            }, value);
          })
        }), increaseMethod === IncreaseMethod.Date && increaseOn && /*#__PURE__*/_jsx(KeyboardDatePicker, {
          style: {
            width: 150
          },
          size: "small",
          "data-testid": "price-increase-date",
          className: styles.noShrink,
          value: increaseOn,
          minDate: minDate,
          maxDate: maxDate,
          disabled: isReadOnly,
          disableErrors: !showServiceValidationWarning,
          helperText: "",
          onChange: newIncreaseOn => newIncreaseOn && handleStateChange({
            enabled: true,
            newIncreaseOn
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: cn(styles.additionalControl, styles.roundPrices),
        children: [/*#__PURE__*/_jsx(Checkbox, {
          className: styles.noShrink,
          checked: shouldRoundPrices,
          disabled: isReadOnly,
          "data-testid": "price-increase-should-round-prices",
          onChange: e => handleStateChange({
            enabled: true,
            newRoundPrices: e.target.checked ? RoundPrices.Down1 : RoundPrices.None
          }),
          children: /*#__PURE__*/_jsx(WithInfoIcon, {
            info: "Automatically rounds prices down to the nearest whole number for customer-friendly pricing.",
            children: /*#__PURE__*/_jsx(Typography, {
              children: "Round prices"
            })
          })
        }), shouldRoundPrices && /*#__PURE__*/_jsx(TextField, {
          select: true,
          size: "small",
          testid: "price-increase-round-prices",
          width: 360,
          disabled: isReadOnly,
          value: roundPrices,
          error: !!roundPricesError,
          helperText: roundPricesError,
          onChange: e => handleStateChange({
            enabled: true,
            newRoundPrices: e.target.value
          }),
          children: roundPricesOptions.map(_ref2 => {
            let {
              value,
              amount
            } = _ref2;
            return /*#__PURE__*/_jsxs(MenuItem, {
              value: value,
              "data-testid": "price-increase-round-prices-".concat(value),
              children: ["Round prices down to the nearest ", utils.formatDollarAmount(amount)]
            }, value);
          })
        })]
      })]
    })
  }, AdvancedSetting.AutoPriceIncrease);
}
function QboClassesControl(props) {
  const {
    info,
    label,
    service,
    testId: testPrefix,
    showServiceValidationWarning,
    isReadOnly,
    onQboClassChange = () => {}
  } = props;
  const qboClasses = useStore(state => state.qboClasses.data);
  const allowToCustomizeQboClasses = useStore(selectors.integration.allowToCustomizeQboClasses);
  const isLoadingClasses = !qboClasses;
  const isClassesFeatureDisabled = !allowToCustomizeQboClasses || !!(qboClasses && !qboClasses.length);
  const integratedClassId = serviceModel.integratedClassId(service);
  const checked = !isClassesFeatureDisabled && integratedClassId != null;
  const errors = serviceModel.validateIntegratedClass(service);
  const selectedOption = useMemo(() => integratedClassId && qboClasses ? qboClasses.find(qboClass => qboClass.id === integratedClassId) : undefined, [integratedClassId, qboClasses]);
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    isReadOnly: isReadOnly,
    info: info,
    label: label,
    checked: checked,
    disabled: isClassesFeatureDisabled || isLoadingClasses,
    disabledTooltip: isClassesFeatureDisabled ? "To override the ".concat(accountingName, " class assignment, classes must first be enabled and defined in ").concat(accountingName, ".") : undefined,
    testid: "".concat(testPrefix, "-toggle-qbo-classes"),
    onChange: newChecked => {
      const newIntegratedClass = newChecked ? serviceModel.makeIntegratedClassSet('') : serviceModel.makeIntegratedClassUnset();
      onQboClassChange(service.id, newIntegratedClass);
    },
    children: checked && /*#__PURE__*/_jsx("div", {
      className: styles.additionalControl,
      children: /*#__PURE__*/_jsx(Autocomplete, {
        selectOnFocus: true,
        multiple: false,
        disabled: isReadOnly,
        size: "small",
        value: selectedOption,
        "data-testid": "".concat(testPrefix, "-select-qbo-class"),
        textFieldProps: {
          label: 'Class',
          placeholder: 'Select class',
          alwaysShrinkLabel: true,
          width: dropdownWidth,
          error: showServiceValidationWarning && errors.length > 0,
          helperText: showServiceValidationWarning && errors[0]
        },
        options: qboClasses || [],
        onChange: (_, newOption) => {
          const id = !newOption || typeof newOption === 'string' ? '' : newOption.id;
          onQboClassChange(service.id, serviceModel.makeIntegratedClassSet(id));
        },
        getOptionLabel: option => !option ? '' : typeof option == 'string' ? option : option.name
      })
    })
  }, AdvancedSetting.QboClasses);
}
function FinancialCentsControl(props) {
  const {
      testId: testPrefix
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const serviceTemplateId = props.service.serviceTemplateId;
  const {
    api
  } = useStoreActions();
  const users = useStore(selectors.integration.financialCentsUsers);
  return /*#__PURE__*/_jsx(PracticeManagementTeamMembersControl, _objectSpread(_objectSpread({}, rest), {}, {
    testId: "".concat(testPrefix, "-financial-cents"),
    users: users,
    onChange: rest.onFinancialCentsChange,
    getRoles: async () => serviceTemplateId ? api.financialCents.getRoles(serviceTemplateId) : []
  }));
}
function KarbonControl(props) {
  const {
      testId: testPrefix
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const serviceTemplateId = props.service.serviceTemplateId;
  const {
    api
  } = useStoreActions();
  const users = useStore(selectors.integration.karbonUsers);
  return /*#__PURE__*/_jsx(PracticeManagementTeamMembersControl, _objectSpread(_objectSpread({}, rest), {}, {
    testId: "".concat(testPrefix, "-karbon"),
    users: users,
    onChange: rest.onKarbonChange,
    getRoles: async () => serviceTemplateId ? api.karbon.getRoles(serviceTemplateId) : []
  }));
}
function PracticeManagementTeamMembersControl(props) {
  const getProps = useStateInRef(props);
  const {
    info,
    label,
    disabled,
    disabledTooltip,
    testId: testPrefix,
    service,
    integration,
    users,
    isReadOnly,
    onChange: _onChange = () => {}
  } = props;
  const [roles, setRoles] = useState();
  const didFetchRolesRef = useRef(false);
  const [checked, setChecked] = useState(() => !!(integration !== null && integration !== void 0 && integration.hasAssignedTeamMembers()));
  useEffect(() => {
    if (!didFetchRolesRef.current && checked) {
      getProps().getRoles().then(setRoles);
      didFetchRolesRef.current = true;
    }
  }, [checked]);
  return /*#__PURE__*/_jsx(AdvancedSettingsControl, {
    info: info,
    label: label,
    checked: checked,
    testid: "".concat(testPrefix, "-toggle-mapping"),
    disabled: disabled,
    isReadOnly: isReadOnly,
    disabledTooltip: disabledTooltip,
    onChange: setChecked,
    children: checked && integration && (roles && users ? roles.map(role => /*#__PURE__*/_jsx("div", {
      className: styles.additionalControl,
      children: /*#__PURE__*/_jsx(Autocomplete, {
        selectOnFocus: true,
        freeSolo: true,
        multiple: false,
        disabled: isReadOnly,
        size: "small",
        value: getSelectedUser(users, role, integration),
        "data-testid": "".concat(testPrefix, "-select-").concat(role.id),
        textFieldProps: {
          label: role.name,
          placeholder: 'Unassigned',
          alwaysShrinkLabel: true,
          width: dropdownWidth
        },
        options: users,
        getOptionLabel: option => option.name,
        onChange: (_, newOption) => {
          const newUserId = !newOption || typeof newOption === 'string' ? null : newOption.id;
          const newIntegration = integration.assignTeamMember(role.id, newUserId);
          _onChange(service.id, newIntegration);
        }
      })
    }, role.id)) : /*#__PURE__*/_jsx(Spinner, {
      size: 40,
      centeredInBox: true,
      centerBoxHeight: 56,
      centerBoxWidth: dropdownWidth,
      "data-testid": "".concat(testPrefix, "-mapping-loading")
    }))
  });
}
export const ServiceAdvancedSettingsTestIds = pathgen('ServiceAdvancedSettingsTestIds', overrideTestIds({
  ServiceAdvancedSettingsTestIds: {
    Prorated: testPrefix => "".concat(testPrefix, "-prorated")
  }
}));
export const ServiceAdvancedSettings = /*#__PURE__*/forwardRef(function ServiceAdvancedSettings(props, ref) {
  const {
    service,
    testId,
    showServiceValidationWarning,
    relationshipState,
    isOpenInitially,
    hideTitle,
    isFreshlyAdded
  } = props;
  const isApprovedRelationship = relationshipState.type === 'approved';
  const {
    PREAPPROVED_AMOUNT_IMPROVMENTS = false
  } = useFeatureFlags();
  const effectiveDate = relationshipState.type === 'approved' ? relationshipState.approved.effectiveDate : relationshipState.type === 'awaitingApproval' ? relationshipState.awaitingApproval.effectiveDate : null;
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(isOpenInitially || serviceModel.isProrated(service) || serviceModel.isOptional(service.participation) || PREAPPROVED_AMOUNT_IMPROVMENTS && serviceModel.hasPreapprovedAmount(service));
  const {
    getNow
  } = useIoContext();
  const now = useMemo(() => getNow(), []);
  const settings = useGetSettings({
    isFreshlyAdded,
    isApprovedRelationship,
    service,
    now,
    effectiveDate
  });
  useImperativeHandle(ref, () => ({
    showAdvancedSettings
  }), [showAdvancedSettings]);
  useEffect(() => {
    if (showServiceValidationWarning) {
      setShowAdvancedSettings(true);
    }
  }, [showServiceValidationWarning]);
  useEffect(() => {
    if (PREAPPROVED_AMOUNT_IMPROVMENTS && serviceModel.hasPreapprovedAmount(service) && !showAdvancedSettings) {
      setShowAdvancedSettings(true);
    }
  }, [PREAPPROVED_AMOUNT_IMPROVMENTS, service, showAdvancedSettings]);
  return settings.length === 0 ? null : showAdvancedSettings ? /*#__PURE__*/_jsxs("div", {
    className: styles.settings,
    "data-testid": testId + '-advanced-settings',
    children: [!hideTitle && /*#__PURE__*/_jsx(Typography, {
      weight: "normal",
      children: "Advanced settings:"
    }), settings.map(_ref3 => {
      let {
          type
        } = _ref3,
        rest = _objectWithoutProperties(_ref3, _excluded3);
      const controlProps = _objectSpread(_objectSpread({
        key: type
      }, props), rest);
      switch (type) {
        case AdvancedSetting.Pause:
          return /*#__PURE__*/_jsx(PausedControl, _objectSpread({}, controlProps));
        case AdvancedSetting.StartAutomaticBillingAt:
          return /*#__PURE__*/_jsx(StartAutomaticBillingAtControl, _objectSpread({}, controlProps));
        case AdvancedSetting.BillOnApproval:
          return /*#__PURE__*/_jsx(BillOnApprovalControl, _objectSpread({}, controlProps));
        case AdvancedSetting.Prorate:
          return /*#__PURE__*/_jsx(ProrateControl, _objectSpread({}, controlProps));
        case AdvancedSetting.Optional:
          return /*#__PURE__*/_jsx(OptionalControl, _objectSpread({}, controlProps));
        case AdvancedSetting.LimitCharges:
          return /*#__PURE__*/_jsx(LimitChargesControl, _objectSpread({}, controlProps));
        case AdvancedSetting.AutoPriceIncrease:
          return /*#__PURE__*/_jsx(AutoPriceIncreaseControl, _objectSpread({}, controlProps));
        case AdvancedSetting.QboClasses:
          return /*#__PURE__*/_jsx(QboClassesControl, _objectSpread({}, controlProps));
        case AdvancedSetting.FinancialCents:
          {
            const integration = service.integrations.financialCentsIntegration();
            return /*#__PURE__*/_jsx(FinancialCentsControl, _objectSpread(_objectSpread({}, controlProps), {}, {
              integration: integration
            }));
          }
        case AdvancedSetting.Karbon:
          {
            const integration = service.integrations.karbonIntegration();
            return /*#__PURE__*/_jsx(KarbonControl, _objectSpread(_objectSpread({}, controlProps), {}, {
              integration: integration
            }));
          }
        case AdvancedSetting.LimitedTimeDiscountOffer:
          {
            return /*#__PURE__*/_jsx(LimitedTimeDiscountOfferControl, _objectSpread({}, controlProps));
          }
        case AdvancedSetting.LimitedTimeDiscountOfferForAgreement:
          {
            return /*#__PURE__*/_jsx(DiscountPeriodControl, _objectSpread({}, controlProps));
          }
        case AdvancedSetting.PreapprovedAmount:
          {
            return /*#__PURE__*/_jsx(PreapprovedAmountControl, _objectSpread({}, controlProps));
          }
      }
    })]
  }) : /*#__PURE__*/_jsx(TextButton, {
    underline: "hover",
    "data-testid": testId + '-open-adv-settings',
    onClick: () => setShowAdvancedSettings(true),
    children: "Show Advanced settings..."
  });
});